import React from "react";
import classnames from "classnames";
import { FormattedMessage } from "react-intl";

import { ChatBubble, Close, Edit, Chat } from "components/Icons";
import Button from "components/Button";
import CNBTextArea from "components/CNBTextArea";

import "./style.scss";

interface IProps {
  input: any;
  maxLength?: number;
}

interface IState {
  isTextareaOpened: boolean;
  newComment: string;
  timeout: any;
}

class Comment extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = {
      isTextareaOpened: false,
      newComment: "",
      timeout: null,
    };
  }

  private toggleTextField(isEdit = false) {
    this.setState({
      isTextareaOpened: !this.state.isTextareaOpened,
      newComment: isEdit ? this.props.input.value : "",
    });
  }

  public render() {
    const {
      input: { value, onChange },
      maxLength,
    } = this.props;
    const { isTextareaOpened, newComment } = this.state;

    return (
      <div id="comment-block">
        {value && (
          <div className="comment-row">
            <div className="left">
              <ChatBubble /> <p>{value}</p>
            </div>
            <div className="right" onClick={() => this.toggleTextField(true)}>
              <Edit /> <FormattedMessage id="EDIT_COMMENT" tagName="span" />
            </div>
            <div className="right" onClick={() => onChange(null)}>
              <Close /> <FormattedMessage id="REMOVE_COMMENT" tagName="span" />
            </div>
          </div>
        )}
        <div
          className={classnames(
            "text-field",
            !isTextareaOpened ? "closed" : ""
          )}
        >
          <CNBTextArea
            rows={2}
            value={newComment}
            onChange={(evt) => {
              this.setState({ newComment: evt.target.value });
            }}
            maxLength={maxLength}
            onBlur={() => {
              // this.setState({ timeout: clearTimeout(this.state.timeout) });
              this.setState({
                timeout: onChange(newComment),
              });
              this.toggleTextField();
            }}
          />
          {/* <div>
            <Button
              kind="primary"
              onClick={() => {
                this.setState({ timeout: clearTimeout(this.state.timeout) });
                this.setState({
                  timeout: setTimeout(() => onChange(newComment), 1000)
                });
                this.toggleTextField();
              }}
            >
              <Chat /> <FormattedMessage id="SAVE_COMMENT" tagName="span" />
              onChange(newComment); this.toggleTextField(); }} disabled={newComment.length ===
                0}
              > ADD_COMMENT
            </Button>
          </div> */}
        </div>
        {!value && (
          <div className="add-comment" onClick={() => this.toggleTextField()}>
            <Chat />
            <FormattedMessage
              id={isTextareaOpened ? "CANCEL" : "ADD_COMMENT"}
              tagName="span"
            />
          </div>
        )}
      </div>
    );
  }
}

export default Comment;
